import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Notification, NotificationType } from '@shared/models';
import { Pagination } from '@shared/pagination';

import { ApiService } from './api.service';
import { ApiParams } from '.';
import { Task, TasksEntityType } from 'mojo-tasks';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService extends ApiService<Notification> {
  constructor(http: HttpClient) {
    super(http);
    this.url = 'notifications';
  }

  getPage(
    apiParams: Partial<ApiParams> = {},
    notificationType: NotificationType[],
  ): Observable<Pagination<Notification>> {
    notificationType.push(NotificationType.ASSIGN);
    const params = { ...apiParams, notificationType: notificationType.join(',') };
    return this.get({ params });
  }

  getUnreadNotificationsCount(notificationType: NotificationType[]): Observable<number> {
    notificationType.push(NotificationType.ASSIGN);
    const params = { notificationType: notificationType.join(','), unread: '', count: '' };
    return this.get({ params });
  }

  markAsRead(): Observable<any> {
    return this.put({ url: '/check' });
  }

  hideNotification(notificationId: number): Observable<any> {
    return this.post({ url: `/hide/${notificationId}` });
  }

  sendNotificationTask(
    entityType: TasksEntityType | string,
    entityId: number,
    payload: Partial<Task>,
    entityName?: string,
    assignedUserPhotoId?: number,
  ): Observable<Task> {
    return this.post({
      url: ``,
      body: {
        ...payload,
        assignedUserName: payload.assignedUser,
        assignedUserPhotoId,
        entityName,
      },
      params: { assign: 'user', entityType, entityId },
    });
  }
}
